<template>
  <div class="m-owner-wrapper">
    <div class="media-owner-dashboard">
      <div class="media-owner-dashboard__title">
        <h1 class="medium-title">All Order</h1>
      </div>
      <div class="media-owner-dashboard__header">
        <div class="media-owner-dashboard__header__left">
          <div class="media-owner-dashboard__header__left__status">
            <a-dropdown-list @selected="selectedStatus" :list="statusList" 
            labelButton="All Status" :valueDisplay="selectedStatusValue" :loading="isLoadingStatus"/>
          </div>
          <div class="media-owner-dashboard__header__left__progress">
            <a-dropdown-list @selected="selectedProgress" :list="progressList" 
            labelButton="All Progress" :valueDisplay="selectedProgressValue" :loading="isLoadingProgress"/>
          </div>
          <div v-if="filtered" class="reset">
            <button class="btn-regular link" @click="resetFilter">Reset</button>
          </div>
        </div>
        <div class="media-owner-dashboard__header__right">
          <div class="media-owner-dashboard__header__right__sort">
            <div class="media-owner-dashboard__header__right__sort__label">Sort by:</div>
            <a-dropdown-sort class="media-owner-dashboard__header__right__sort__dropdown" :value.sync="selectedSortValue" :type="true" :options="sortOptions"></a-dropdown-sort>
          </div>
        </div>
      </div>
      <div class="media-owner-dashboard__table">
          <table class="table-media-owner">
            <thead>
              <tr>
                <th class="campaign-header mini-font">CAMPAIGN </th>
                <th class="client-header mini-font">CLIENT</th>
                <th class="order-status-header">
                  <div class="items">
                    <span class="mini-font">ORDER STATUS</span>
                    <tooltip text="Order Status">
                      <span slot="content">
                        <i class="adx-ic_info color-grey" ></i>
                      </span>
                    </tooltip>

                  </div>
                </th>
                <th class="progress-header">
                  <div class="items">
                    <span class="mini-font">PROGRESS</span>
                    <tooltip text="Progress Status">
                      <span slot="content">
                        <i class="adx-ic_info color-grey" ></i>
                      </span>
                    </tooltip>
                  </div>
                </th>
                <th class="price-header">
                  <div class="items">
                    <span class="mini-font">TOTAL NET PRICE</span>
                  </div>
                </th>
                <th class="payment-header mini-font">
                  <div class="items">
                    <span class="mini-font">CLIENT PAYMENT</span>
                    <tooltip text="Client Payment">
                      <span slot="content">
                        <i class="adx-ic_info color-grey" ></i>
                      </span>
                    </tooltip>
                  </div>
                </th>
                <th class="payment-header mini-font">
                  <div class="items">
                    <span class="mini-font">ADX PAYMENT</span>
                    <tooltip text="ADX Payment">
                      <span slot="content">
                        <i class="adx-ic_info color-grey" ></i>
                      </span>
                    </tooltip>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody v-if="!isLoading && !isEmpty">
              <tr v-for="(item, index) in items" :key="index">
                <td><span class="subhead strong">{{ item.campaign_name }}</span></td>
                <td><span class="subhead">{{item.brand}}</span></td>
                <td>
                  <adx-label-custom :type="'custom-label-v2'" :labelStyle="getDisplayStatus(item.order_status)" 
                    :label="getLabelName(item.order_status)"/>
                </td>
                <td>
                  <adx-label-custom :type="'custom-label-v2'" :labelStyle="getDisplayStatus(item.progress_status)" 
                    :label="getLabelName(item.progress_status)"/>
                </td>
                <td><span class="color-pink subhead strong">{{ item.net_price | formatMoney }}</span></td>
                <td>
                  <div>
                    <span v-if="item.installments.length > 0" class="subhead">{{item.installments[0].client_payment_amount | formatMoney }}</span>
                    <span v-else class="subhead">{{'-'}}</span>
                  </div>
                  <div>
                    <span class="subhead">{{item.installments.length > 0 ? (displayDate(item.installments[0].client_due_date_payment)) : '-'}}</span>
                  </div>
                  <div v-if="item.installments.length > 0" class="view-detail" @click="viewDetail('client',item.installments )">
                    <span class="mini-font color-pink strong">{{ 'View Detail' }}</span>
                    <span class="icon-chevronright mini-font color-pink"></span>
                  </div>
                </td>
                <td>
                  <div>
                    <span v-if="item.installments.length > 0" class="subhead">{{item.installments[0].vendor_payment_amount | formatMoney}}</span>
                    <span v-else class="subhead">{{'-'}}</span>
                  </div>
                  <div>
                    <span class="subhead">{{item.installments.length > 0 ? (displayDate(item.installments[0].vendor_receipt_due_date)) : '-'}}</span>
                  </div>
                  <div v-if="item.installments.length > 0" class="view-detail" @click="viewDetail('adx', item.installments)">
                    <span class="mini-font color-pink strong">{{ 'View Detail' }}</span>
                    <span class="icon-chevronright mini-font color-pink"></span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="!isLoading && isEmpty" class="emptyLoadingState">
              <tr>
                <td colspan="100">
                  <a-emptystate />
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading" class="emptyLoadingState">
              <tr>
                <td colspan="100">
                  <a-loading />
                </td>
              </tr>
            </tbody>
          </table>
          <a-pagination
            v-if="!isLoading && !isEmpty"
            :selectedPage="selectedPage"
            :maxPage="maxPage"
            @change-page="selectPage"
          />
      </div>
      <a-modal
        v-if="isShowModal"
        @modal-close="toggleModal()"
        class="media-owner-dashboard__modal"
        :noTitle="true"
        :type="'small'">
        <div slot="content">
          <div class="media-owner-dashboard__modal__wrapper">
            <h1 class="smedium-title title">{{isClient ? 'Client Payment' : 'Adx Payment'}}</h1>
            <div v-if="installment" class="media-owner-dashboard__modal__wrapper__header">
              <div class="media-owner-dashboard__modal__wrapper__header__top">
                <div class="subhead">Next Receipt </div>
                <div class="subhead">{{displayDate(isClient ? installment[0].client_due_date_payment: installment[0].vendor_receipt_due_date)}}</div>
              </div>
              <div class="media-owner-dashboard__modal__wrapper__header__center">
                <div class="subhead">Ammount</div>
                <div class="subhead color-pink">{{(isClient ? installment[0].client_payment_amount : installment[0].vendor_payment_amount  ) | formatMoney}}</div>
              </div>
              <div class="media-owner-dashboard__modal__wrapper__header__bottom">
                <div class="subhead">Status</div>
                 <adx-label-custom :type="'custom-label-v2'" :labelStyle="getDisplayStatus(isClient ? installment[0].client_payment_status : installment[0].vendor_payment_status)" 
                 :label="getLabelName(isClient ? installment[0].client_payment_status : installment[0].vendor_payment_status)"/>
              </div>
            </div>
            <div v-else class="" >
              <a-emptystate />
            </div>
            <div class="media-owner-dashboard__modal__wrapper__body">
              <div>
                <div class="title"><span class="mini-font">INSTALLMENT TABLE</span></div>
                <table class="table-modal">
                  <thead>
                    <tr>
                      <th><span class="mini-font">NO</span></th>
                      <th><span class="mini-font">AMMOUNT</span></th>
                      <th><span class="mini-font">DUE DATE</span></th>
                      <th><span class="mini-font">STATUS</span></th>
                    </tr>
                  </thead>
                  <tbody v-if="installment.length > 0">
                    <tr v-for="(item, index) in installment" :key="index">
                      <td><span class="subhead">{{index + 1}}</span></td>
                      <td>
                        <span class="subhead strong">{{(isClient ? item.client_payment_amount: (item.vendor_payment_amount)) | formatMoney}}</span>
                      </td>
                      <td>
                        <span class="subhead">{{displayDate(isClient ? item.client_due_date_payment: item.vendor_receipt_due_date)}}</span>
                      </td>
                      <td>
                        <adx-label-custom :type="'custom-label-v2'" :labelStyle="getDisplayStatus(isClient ? item.client_payment_status : item.vendor_payment_status)" 
                        :label="getLabelName(isClient ? item.client_payment_status : item.vendor_payment_status)"/>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="installment.length == 0" class="emptyLoadingState">
                    <tr>
                      <td colspan="100">
                        <a-emptystate />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="media-owner-dashboard__modal__wrapper__body__close">
                <button class="btn-large secondary" @click="toggleModal()">Close</button>
              </div>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import lib from "@/lib/util";
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from '@/lib/mixins/globalMixins'
import { helpers } from '@/lib/validation/'
import { mapListFilter } from "@/lib/transformer";

import Pagination from '@/components/Pagination';
// import LabelStatusCustom from '@/components/StatusLabelCustom'
import Tooltip from '@/components/Tooltip'

import { formatShortDate } from '@/lib/util';
import { 
  ASelectDropdown, 
  ALoadingPrimary, 
  AModal, 
  APagination, 
  ATable, 
  AListDropdown, 
  AEmptySelection,  
  AStatusLabelCustom, 
} from "ui-kit-v1"

export default {
  name: 'adx-pricelist',
  components: {
    'a-table': ATable,
    'a-pagination': APagination,
    'a-dropdown-sort': ASelectDropdown,
    'a-modal': AModal,
    'a-loading': ALoadingPrimary,
    'a-dropdown-list': AListDropdown,
    'a-emptystate': AEmptySelection,
    'adx-label-custom': AStatusLabelCustom,
    'tooltip': Tooltip,
  },
  mixins: [ globalMixins ],
  props: {

  },
  data() {
    return {
      maxPage: 1,
      selectedPage: 1,
      isLoading: false,
      isLoadingStatus: false,
      isLoadingProgress: false,
      isEmpty: false,
      isShowModal: false,
      isClient: false,
      selectedStatusValue: '',
      selectedProgressValue: '',
      selectedSortValue: 'last_updated',
      labelStyle: {
        'bgColor': '#b8e7f9',
        'color': '#102b36',
        'borderColor' : '#74bedc'
      },
      sortOptions: [
        {
          label: "Name",
          value: "name_asc",
        },
        {
          label: "Last Added",
          value: "last_updated",
        },
        {
          label: "First Added",
          value: "first_added",
        },
        {
          label: "Higest Price",
          value: "highest_price",
        },
        {
          label: "Lowest Price",
          value: "lowest_price",
        },
      ],
      statusList: [],
      progressList: [],
      items: [],
      installment: [],
      tableIds: [],
    }
  },
  computed: {
    filtered: function() {
      let filtered = false;
      if(this.selectedStatusValue || this.selectedProgressValue){
        filtered = true
      }
      return filtered
    }
  },
  watch: {
    selectedSortValue: function() {
      this.selectedPage = 1;
      this.loadData()
    },
    selectedPage: function() {
      this.loadData()
    },
    selectedStatusValue: function() {
      this.selectedPage = 1;
      this.loadData()
    },
    selectedProgressValue: function() {
      this.selectedPage = 1;
      this.loadData()
    }
  },
  beforeCreate() {

  },
  created() {
    this.loadData()
    this.loadFilter()
  },
  beforeMount() {

  },
  mounted() {
  
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      this.isEmpty = false
      this.tableIds = []
      let params = {
        page: this.selectedPage,
        sort: this.selectedSortValue,
        order_status: this.selectedStatusValue || undefined,
        progress_status: this.selectedProgressValue || undefined,
      }
      const { data, status } = await api.get(restEdge.dashboardMediaOwnerList, { 
        params: params, 
        needToken: true, 
        useRestEdge: true 
      })
      if (status === 200) {
        this.items = data.results
        this.maxPage = data.maxPage
        if (!this.items.length) this.isEmpty = true
      } else {
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
      this.isLoading = false
    },
    async loadFilter(){
      this.isLoadingStatus = true
      this.isLoadingProgress =  true
      const { data, status } = await api.get(restEdge.filterMediaOwnerList,{ 
        needToken: true, 
        useRestEdge: true 
        });
      if (status === 200) {
        this.statusList = mapListFilter({
          obj: data.order_status,
          id: `id`,
          value: `value`,
          label: `name`
        });
        this.progressList = mapListFilter({
          obj: data.progress_status,
          id: `id`,
          value: `value`,
          label: `name`
        });
      }
      this.isLoadingStatus = false
      this.isLoadingProgress =  false
    },
    selectedStatus(items){
      this.selectedStatusValue = items.value
    },
    selectedProgress(items){
      this.selectedProgressValue = items.value
    },
    resetFilter(){
      this.selectedStatusValue = ''
      this.selectedProgressValue = ''
    },
    selectPage(item) {
      this.selectedPage = item
    },
    viewDetail(subject, data){
      this.isShowModal = true
      subject == 'client'? this.isClient = true : this.isClient = false
      this.installment = data
    }, 
    toggleModal(){
      this.isShowModal = false
    },
    displayDate(date) {
      return `${lib.dateFormat("YYYY-MM-DD", "DD MMM YYYY", new Date(date))}`;
    },
    getLabelName(label){
      return label.toUpperCase()
    },
    getDisplayStatus(status) {
      let value = status.toLowerCase()
      let labelStyle = {}
      let blueLabelStatus = ['outstanding','order submitted','order validated','order validated','verified', 'agreement']
      let yellowLabelStatus = [`invoiced`, `waiting for content`,`content submitted`,`content approval`,`production`]
      let toscaLabelStatus = [`paid`,`running`,`bast uploaded`,`done`,`report uploaded`]
      let redLabelStatus = [`overdue`,`receipted`]
      let greyLabelStatus = [`expired`, `cancel`]

      if(blueLabelStatus.includes(value)){
        labelStyle = { bgColor: '#b8e7f9', color: '#102b36',  borderColor: '#74bedc'}
      }else if(yellowLabelStatus.includes(value)){
        labelStyle = { bgColor: '#fff6e8', color: '#102b36',  borderColor: '#ff9500'}
      }else if(toscaLabelStatus.includes(value)){
        labelStyle = { bgColor: '#cafff3', color: '#102b36',  borderColor: '#44d7b6'}
      }else if(redLabelStatus.includes(value)){
        labelStyle = { bgColor: '#ffd4dc', color: '#e02020',  borderColor: '#e02020'}
      }else if(greyLabelStatus.includes(value)){
        labelStyle = { bgColor: '#fafafa', color: '#102b36',  borderColor: '#999'}
      }
      return labelStyle
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang="scss">

</style>
